export default __webpack_public_path__ + "static/media/Hundered_b_DNA_Ladder_Marker_M.d090cec8.svg";